import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight, FiCheckCircle } = FiIcons;

const Hero = () => {
  const scrollToHowItWorks = (e) => {
    e.preventDefault();
    const section = document.getElementById('how-it-works');
    if (section) {
      section.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  const scrollToCalculator = (e) => {
    e.preventDefault();
    const section = document.getElementById('calculator');
    if (section) {
      section.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  return (
    <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[800px] pointer-events-none -z-10">
        <div className="absolute top-[-10%] left-[20%] w-[500px] h-[500px] bg-brand-100/50 rounded-full blur-[120px]"></div>
        <div className="absolute top-[10%] right-[20%] w-[400px] h-[400px] bg-blue-50/50 rounded-full blur-[100px]"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-50 border border-brand-100 text-brand-700 text-sm font-bold mb-8">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-brand-500"></span>
              </span>
              Updated for 2024 EPF Rates
            </div>

            <h1 className="text-5xl md:text-7xl font-black text-slate-900 tracking-tight mb-8 leading-[1.1]">
              Calculate Your EPF Savings <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-600 to-blue-400">
                In Less Than 10 Seconds
              </span>
            </h1>

            <p className="text-xl text-slate-600 mb-12 max-w-2xl mx-auto leading-relaxed">
              Plan your retirement in Malaysia with a simple, accurate, and powerful EPF calculator. Get clear estimates of your future wealth — no signup required.
            </p>

            <div className="flex flex-col sm:flex-row gap-5 justify-center items-center">
              <a 
                href="#calculator" 
                onClick={scrollToCalculator}
                className="btn-primary group w-full sm:w-auto px-8 py-4 text-lg"
              >
                Try Free Calculator
                <SafeIcon icon={FiArrowRight} className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </a>
              <a 
                href="#how-it-works" 
                onClick={scrollToHowItWorks}
                className="btn-secondary w-full sm:w-auto px-8 py-4 text-lg"
              >
                See Methodology
              </a>
            </div>

            <div className="mt-16 flex flex-wrap justify-center gap-x-10 gap-y-4">
              {['No credit card required', '100% Privacy focus', '2024 Rates'].map(text => (
                <div key={text} className="flex items-center gap-2 text-slate-500 font-medium">
                  <SafeIcon icon={FiCheckCircle} className="text-brand-500 w-5 h-5" />
                  {text}
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;